import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import { ResourceContractorSchemaListRequest } from './ResourceContractorSchemaListRequest';
import { buildOptions } from '../../../utils/OptionsManager';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { FormSelect } from '../../FormSelect';
import { ResourceContractorSchemaListTask } from './ResourceContractorSchemaListTask';
import LinkButton from '../../LinkButton';
import { Modal } from 'react-bootstrap';
import QRCode from 'react-qr-code';
import { QrWorkerTokenRequest } from './worker-qr/QrWorkerTokenRequest';
import { QrWorkerTokenTask } from './worker-qr/QrWorkerTokenTask';
import { PsQrWorkerToken } from '../../../../my-outsources/worker/PsQrWorkerToken';
import { QrMachineTokenRequest } from './machine-qr/QrMachineTokenRequest';
import { QrMachineTokenTask } from './machine-qr/QrMachineTokenTask';
import { PsQrMachineToken } from '../../../../my-outsources/machine/PsQrMachineToken';
import { FormText } from '../../FormText';

export class ResourceContractorSchema extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            schemas: [],
            qrToken: '',
            showQrModal: false,
        };
    }

    componentDidMount() {
        this.listContractorSchemas();
        this.getQrToken();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            refreshQrToken,
            handleSetRefreshQrToken,
        } = this.props;

        if ( refreshQrToken && refreshQrToken !== prevState.refreshQrToken ) {
            handleSetRefreshQrToken(false);
            this.getQrToken();
        }
    }

    getQrToken() {
        const {
            workerId,
            machineId,
        } = this.props;

        if ( workerId ) {
            this.getQrWorkerToken();
        }
        if ( machineId ) {
            this.getQrMachineToken();
        }
    }

    handleShowQr = (qrToken) => {
        this.setState({
            qrToken: qrToken,
            showQrModal: true,
        });
    };

    render() {
        const {
            schemas,
            qrToken,
        } = this.state;
        const {
            name,
            label,
            testId,
            disabled,
            canWrite,
            showPositionField,
        } = this.props;

        return (
            <React.Fragment>
                <Field
                    col={'col-md-6'}
                    name={name}
                    label={label}
                    testId={testId}
                    options={schemas}
                    displayEmptyOption={true}
                    disabled={disabled}
                    component={FormSelect}
                />
                {
                    showPositionField &&
                    <Field
                        col={'col-md-4'}
                        name={'position'}
                        label={I18nUtils.tr('TR_OFICIO_SEGUN_FORMACION_CONVENIO')}
                        placeholder={I18nUtils.tr('TR_INTRODUCE_EL_OFICIO_SEGUN_FORMACION_CONVENIO')}
                        component={FormText}
                        disabled={!canWrite}
                    />}
                {
                    qrToken &&
                    <div className="col-sm-2 m-t-30">
                        <div onClick={() => this.handleShowQr(qrToken)}>
                            <LinkButton
                                to={() => null}
                                text={I18nUtils.tr('TR_VER_QR')}
                                className={'btn-block btn-sm bold'}
                            />
                        </div>
                    </div>
                }
                {this.renderQrModal()}
            </React.Fragment>
        );
    }

    renderQrModal() {
        const {
            workerId,
        } = this.props;
        const {
            showQrModal,
            qrToken,
        } = this.state;

        const title = workerId ? 'TR_DATOS_DEL_TRABAJADOR' : 'TR_DATOS_DE_LA_MAQUINA';

        return (
            <Modal
                show={showQrModal}
                onHide={() => this.setState({ showQrModal: false })}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-sm">
                        {I18nUtils.tr(title)}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={'qr-modal-body'}>
                        <QRCode
                            value={qrToken}
                            size={256}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        );
    }

    listContractorSchemas = () => {
        const { documentSchemaType } = this.props;
        const request = new ResourceContractorSchemaListRequest(documentSchemaType);
        new ResourceContractorSchemaListTask(request)
            .onSuccess((res) => this.setState({ schemas: buildOptions(res.data) }))
            .onFail(error => Alert.error(error))
            .execute();
    };

    getQrWorkerToken = () => {
        const {
            workerId,
            contractorId,
            handleTokenLoading,
        } = this.props;

        const request = new QrWorkerTokenRequest();

        request.setContractorId(contractorId);
        request.setId(workerId);

        handleTokenLoading(true);
        new QrWorkerTokenTask(request)
            .onSuccess(res => {
                const qrWorkerToken = PsQrWorkerToken.fromApiQrWorkerToken(res.data);
                this.setState({ qrToken: qrWorkerToken.qrInfo() });
                handleTokenLoading(false);
            })
            .onFail(error => Alert.error(error))
            .execute();
    };

    getQrMachineToken = () => {
        const {
            machineId,
            contractorId,
            handleTokenLoading,
        } = this.props;

        const request = new QrMachineTokenRequest();

        request.setContractorId(contractorId);
        request.setId(machineId);

        handleTokenLoading(true);
        new QrMachineTokenTask(request)
            .onSuccess(res => {
                const qrMachineToken = PsQrMachineToken.fromApiQrMachineToken(res.data);
                this.setState({ qrToken: qrMachineToken.qrInfo() });
                handleTokenLoading(false);
            })
            .onFail(error => Alert.error(error))
            .execute();
    };
}

ResourceContractorSchema.propTypes = {
    col: PropTypes.string,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    testId: PropTypes.string,
    disabled: PropTypes.bool,
    documentSchemaType: PropTypes.number.isRequired,
    workerId: PropTypes.number,
    machineId: PropTypes.number,
    contractorId: PropTypes.number,
    handleSetRefreshQrToken: PropTypes.func,
    refreshQrToken: PropTypes.bool,
    handleTokenLoading: PropTypes.func,
    canWrite: PropTypes.bool,
    showPositionField: PropTypes.bool,
};

ResourceContractorSchema.defaultProps = {
    label: I18nUtils.tr('TR_ESQUEMA_DOCUMENTACION'),
    testId: 'form-document-schema',
};



// WEBPACK FOOTER //
// ./src/app/shared/components/predefined-fields/resource-contractor-schema/ResourceContractorSchema.jsx